import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { QueryParamProvider } from 'use-query-params';
import AppContext from './AppContext';
import AppManager from './AppManager';
import './styles/app.css';
import '../../assets/fonts/fonts.css';

const AppProvider = ({ children, location }) => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState(false);

  const isClient = typeof window !== 'undefined';

  const isPublicRoute = location.pathname.startsWith('/womex');

  const content = (
    <AppContext.Provider
      value={{
        user,
        setUser,
        error,
        setError,
      }}
    >
      {isPublicRoute ? (
        children
      ) : (
        <AppManager location={location}>{children}</AppManager>
      )}
    </AppContext.Provider>
  );

  // Solo usar QueryParamProvider en el cliente
  if (isClient) {
    return <QueryParamProvider>{content}</QueryParamProvider>;
  }

  return content;
};

AppProvider.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
};

export default AppProvider;
